<template lang="pug">
  .service-popup
    .service-popup__overlay
      .service-popup__wrap
        .service-popup__decor
        .service-popup__close(
          @click="closePopup()"
        )
        .service-popup__content
          slot(:closePopup="closePopup")
</template>
<script>
export default {
  name: "ServicePopup",
  mounted() {
    window.addEventListener("keydown", this.escHandler);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.escHandler);
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
  },
  escHandler(e) {
    const key = e.key || e.keyIdentifier || e.keyCode;
    if (key === 27) {
      this.closePopup();
    }
  },
};
</script>

<style lang="scss">
@import "../style/service-popup.scss";
</style>
